import React, { useState } from 'react';
import { BONOS } from '../data/content';
import { IMG_PACK_PRINCIPAL } from '../utils/constants';
interface Piece {
  src: string;
  alt: string;
  width: number;
  x: number;
  rot: number;
  z: number;
}
const PIECES: Piece[] = [{
  src: BONOS[2].img,
  alt: 'Bono: Cuando escribir cuesta',
  width: 20.2,
  x: 15,
  rot: -14,
  z: 1
}, {
  src: BONOS[1].img,
  alt: 'Bono: Qué corregir y qué dejar pasar',
  width: 22.9,
  x: 24.5,
  rot: -9,
  z: 2
}, {
  src: BONOS[0].img,
  alt: 'Bono: Cuaderno para zurdos',
  width: 25.6,
  x: 35,
  rot: -4.5,
  z: 3
}, {
  src: IMG_PACK_PRINCIPAL,
  alt: 'Kit de Caligrafía: 400 actividades en 21 días, 6 tomos',
  width: 36.9,
  x: 50,
  rot: 0,
  z: 9
}, {
  src: BONOS[3].img,
  alt: 'Bono: Informe de avance para la escuela',
  width: 25.3,
  x: 65,
  rot: 4.5,
  z: 3
}, {
  src: BONOS[4].img,
  alt: 'Bono: 50 ejercicios sin lápiz',
  width: 22.8,
  x: 75.5,
  rot: 9,
  z: 2
}, {
  src: BONOS[5].img,
  alt: 'Bono: 30 juegos de escritura',
  width: 20.1,
  x: 85,
  rot: 14,
  z: 1
}];
interface PackFanProps {
  className?: string;
  onClick?: () => void;
  lazy?: boolean;
}
export function PackFan({
  className = '',
  onClick,
  lazy = false
}: PackFanProps) {
  const [open, setOpen] = useState(false);
  const interactive = typeof onClick === 'function';
  return <div className={`relative w-full aspect-[3/2] overflow-visible ${interactive ? 'cursor-pointer' : ''} ${className}`} style={{
    overflow: 'visible'
  }} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onClick={onClick} role={interactive ? 'button' : undefined} tabIndex={interactive ? 0 : undefined} onKeyDown={e => {
    if (interactive && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick?.();
    }
  }} data-id="element-34" data-mp="1f7h5kfrdbh28">
      {PIECES.map(piece => {
      const x = open ? 50 + (piece.x - 50) * 1.35 : piece.x;
      const rot = open ? piece.rot * 1.15 : piece.rot;
      return <img key={piece.src + piece.x} src={piece.src} alt={piece.alt} loading={lazy ? 'lazy' : 'eager'} className="absolute select-none pointer-events-none" style={{
        width: `${piece.width}%`,
        left: `${x}%`,
        bottom: '8%',
        zIndex: piece.z,
        transform: `translateX(-50%) rotate(${rot}deg)`,
        transformOrigin: 'bottom center',
        transition: 'transform 500ms ease-out, left 500ms ease-out'
      }} data-id="element-35" data-mp="124ephscej1mc" />;
    })}
    </div>;
}